function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'charcoal': 'rgb(83, 81, 88)','dark-chocolate': 'rgb(52, 40, 39)','heather-navy': 'rgb(65, 68, 81)','heather-red': 'rgb(209, 74, 85)','heather-royal': 'rgb(104, 119, 196)','dark-heather': 'rgb(64, 64, 66)','natural': 'rgb(241, 233, 216)','sand': 'rgb(209, 197, 179)','heather-grey': 'rgb(157, 157, 157)','smoked-paprika': 'rgb(162, 95, 96)','pale-pink': 'rgb(225, 206, 197)','ash': 'rgb(222, 219, 226)','black-heather': 'rgb(79, 79, 79)','sandstone': 'rgb(216, 208, 188)','athletic-heather': 'rgb(175, 179, 184)','classic-pink': 'rgb(235, 201, 202)','antique-denim': 'rgb(58, 66, 70)','desert-pink': 'rgb(222, 159, 151)','stonewash-denim': 'rgb(165, 183, 191)','bone': 'rgb(218, 217, 208)','navy-blazer': 'rgb(29, 46, 70)','team-red': 'rgb(209, 27, 55)','mauve': 'rgb(154, 110, 105)','heliconia': 'rgb(216, 74, 124)','royal': 'rgb(20, 73, 142)','irish-green': 'rgb(27, 138, 68)','heather-grey-black': 'rgb(64, 64, 66)','natural-midnight-navy': 'rgb(65, 68, 81)','natural-black': 'rgb(38, 30, 40)','white-black': 'rgb(255, 255, 255)','butter': 'rgb(238, 217, 155)','berry': 'rgb(107, 77, 97)','blue-jean': 'rgb(88, 102, 122)','denim': 'rgb(64, 69, 81)','graphite': 'rgb(87, 82, 86)','midnight': 'rgb(67, 75, 98)','moss': 'rgb(103, 111, 97)','periwinkle': 'rgb(89, 99, 163)','sage': 'rgb(97, 91, 71)','flo-blue': 'rgb(127, 141, 209)','true-navy': 'rgb(29, 48, 70)','pepper': 'rgb(87, 88, 85)','asphalt': 'rgb(101, 104, 106)','cardinal': 'rgb(130, 64, 67)','dark-grey-heather': 'rgb(61, 61, 61)','yam': 'rgb(185, 112, 72)','espresso': 'rgb(114, 92, 81)','citrus': 'rgb(248, 186, 97)','army': 'rgb(112, 107, 97)','antique-gold': 'rgb(221, 144, 64)','heather-indigo': 'rgb(100, 113, 134)','heather-irish-green': 'rgb(98, 204, 143)','heather-yellow-gold': 'rgb(240, 187, 80)','old-gold': 'rgb(196, 158, 108)','shiraz': 'rgb(138, 101, 132)','stonewash-green': 'rgb(150, 170, 168)','blossom': 'rgb(237, 196, 217)','grape': 'rgb(99, 92, 135)','granite': 'rgb(133, 133, 133)','coral-silk': 'rgb(223, 103, 109)','carolina-blue': 'rgb(113, 151, 211)','azalea': 'rgb(236, 133, 178)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
